import { render, staticRenderFns } from "./GroupDropdown.vue?vue&type=template&id=755476b4&scoped=true&"
import script from "./GroupDropdown.vue?vue&type=script&lang=js&"
export * from "./GroupDropdown.vue?vue&type=script&lang=js&"
import style0 from "./GroupDropdown.vue?vue&type=style&index=0&id=755476b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755476b4",
  null
  
)

export default component.exports